import React, { FC } from 'react';
import styled from 'styled-components';
import { media } from 'src/styles/designs';
import { PimImage } from 'src/components/common/PimImage';
import { useTranslateItem } from 'src/hooks/directus/useTranslateItem';
import { BaseProductDTO } from 'src/models/pim';
import { TrackedLink } from 'src/components/TrackedLink';
import { route } from 'src/services/route';

const ImageContainer = styled.div`
  position: relative;
  height: 136px;
  width: 100%;

  img {
    object-fit: contain;
  }

  ${media.w.greaterThanOrEqual.desktop} {
    height: 180px;
  }
`;

const Title = styled.h2`
  font-weight: 300;
  line-height: 21px;
  letter-spacing: 0.08em;
  text-transform: uppercase;
  text-align: center;
  font-size: 14px;
  margin-top: 10px;

  ${media.w.greaterThanOrEqual.desktop} {
    font-size: 18px;
    margin-top: 27px;
  }
`;

const Container = styled.a`
  min-width: 150px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;

  &:hover {
    cursor: pointer;
  }
`;

interface ProductsSectionItemProps {
  product: BaseProductDTO;
}

export const ProductsSectionItem: FC<ProductsSectionItemProps> = ({
  product,
}) => {
  const translatedProduct = useTranslateItem(product);

  if (!product?.image?.id) {
    return null;
  }

  return (
    <TrackedLink href={route.products().page(product)} passHref>
      <Container>
        <ImageContainer>
          <PimImage
            src={product.image.id}
            alt={translatedProduct.name}
            layout="fill"
            sizes="(min-width: 1000px) 33vw, 50vw"
            quality={100}
          />
        </ImageContainer>
        <Title>{translatedProduct.name}</Title>
      </Container>
    </TrackedLink>
  );
};
